import {
  HELP,
  DASHBOARD,
  LM_DASHBOARD,
  HR_DASHBOARD,
  ESS,
  MY_PROFILE,
  LEAVE_FOR_EMPLOYEE,
  APPRAISAL,
  APPR_PARAM,
  APPROVAL_WORKFLOW,
  COMP_OFF_CONFIG,
  EMP_CODE_CONFIG,
  SECTION,
  UNIT,
  ATTENDANCE_FOR_EMPLOYEE,
  LEAVE_ATTN,
  EMPLOYEE_ATTENDANCE,
  EMPLOYEE_LEAVE,
  TEAM_ATTENDANCE,
  CALENDAR,
  DEPARTMENT,
  DESIGNATION,
  EMPLOYEE,
  EMPLOYEE_PAYROLL,
  EMPLOYEE_USER_MAPPING,
  EMP_TYPE,
  EMPLOYMENT_STATUS,
  GRADES,
  HOLIDAY,
  HRM,
  INCREMENT,
  LEAVE_TYPE,
  COMP_OFF_FOR_EMPLOYEE,
  ATTENDANCE_REQUEST,
  MY_LEAVE,
  OFFICE_LOCATION,
  PAYROLL,
  PAYROLL_BANK_CONFIG,
  PAYROLL_ELM,
  SETTINGS,
  SHIFTS,
  WEEKEND,
  PAYROLL_RUNS,
  TAX_CONFIG,
  PROVIDENT_FUND,
  GRATUITY_FUND,
  ATTENDANCE_PAY,
  AMOUNT_ROUNDING,
  MY_PAYSLIPS,
  ALL_PAYSLIPS,
  MY_TAX_CERT,
  MY_PF,
  MY_GF,
  MY_COMP_OFF,
  ALL_TAX_CERT,
  APPROVALS,
  MY_REQUESTS,
  PENDING_APPROVALS,
  PROMOTION,
  SEPARATION,
  LOAN_ADVANCE,
  MY_LOANS,
  REPORTS,
  RPT_EMPLOYEE,
  RPT_APPRAISAL,
  RPT_PAYROLL,
  RPT_ATTN_SUMMARY,
  RPT_MONTHLY_ATTENDANCE,
  RPT_PF,
  RPT_GF,
  RPT_TAX_CERT,
} from '@constants/internal-route.constant'
import {useMyContext} from '@context/MyContext'
import {usePermissions} from '@services/helper/permission.helper'
import {useT} from 'utility/useT'
import {SidebarMenuItem} from './SidebarMenuItem'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {
  APPROVAL_ROUTES,
  ESS_ROUTES,
  HRM_ROUTES,
  LEAVE_ATTN_ROUTES,
  PAYROLL_ROUTES,
  REPORTS_ROUTES,
  SETTINGS_ROUTES,
} from './menu-routes'

// The whole hrm navigation: dashboards, the feature groups (formerly the header dropdowns),
// then Help. Group children are `gated` (hidden without the feature grant) and each group is
// hidden when none of its children survive — see menu-routes.ts.
export const SidebarMenuMain = () => {
  const t = useT()
  const {isLineManager} = useMyContext()
  const {hasFeature} = usePermissions()

  return (
    <>
      {/* Each dashboard is a grant (HRM_DASH_MY / _TEAM / _HR on Role Permission); Team also needs a
          direct report. */}
      {hasFeature(DASHBOARD) && (
        <SidebarMenuItem to={DASHBOARD} title='My Dashboard' fontIcon='bi-columns-gap' />
      )}
      {isLineManager && hasFeature(LM_DASHBOARD) && (
        <SidebarMenuItem to={LM_DASHBOARD} title='Team Dashboard' fontIcon='bi-people' />
      )}
      {hasFeature(HR_DASHBOARD) && (
        <SidebarMenuItem to={HR_DASHBOARD} title='HR Dashboard' fontIcon='bi-building' />
      )}

      <SidebarMenuItemWithSub
        to={ESS}
        title={t('MENU.ESS')}
        fontIcon='bi-person-circle'
        anyOf={ESS_ROUTES}
        defaultOpen
      >
        <SidebarMenuItem
          gated
          fontIcon='bi-person-badge'
          to={MY_PROFILE}
          title={t('MENU.MY_PROFILE')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-fingerprint'
          to={ATTENDANCE_REQUEST}
          title={t('MENU.ATTENDANCE_REQUEST')}
        />
        <SidebarMenuItem gated fontIcon='bi-calendar-x' to={MY_LEAVE} title={t('MENU.MY_LEAVE')} />
        <SidebarMenuItem
          gated
          fontIcon='bi-calendar-plus'
          to={MY_COMP_OFF}
          title={t('MENU.MY_COMP_OFF')}
        />
        <SidebarMenuItem gated fontIcon='bi-wallet' to={MY_LOANS} title={t('MENU.MY_LOANS')} />
        <SidebarMenuItem
          gated
          fontIcon='bi-receipt'
          to={MY_PAYSLIPS}
          title={t('MENU.MY_PAYSLIPS')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-file-earmark-text'
          to={MY_TAX_CERT}
          title={t('MENU.MY_TAX_CERT')}
        />
        <SidebarMenuItem gated fontIcon='bi-piggy-bank' to={MY_PF} title={t('MENU.PF_BALANCE')} />
        <SidebarMenuItem gated fontIcon='bi-safe' to={MY_GF} title={t('MENU.GF_BALANCE')} />
        <SidebarMenuItem
          gated
          fontIcon='bi-diagram-2'
          to={TEAM_ATTENDANCE}
          title={t('MENU.TEAM_ATTENDANCE')}
        />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to={HRM}
        title={t('MENU.HRM')}
        fontIcon='bi-person-vcard'
        anyOf={HRM_ROUTES}
      >
        <SidebarMenuItem
          gated
          fontIcon='bi-person-vcard'
          to={EMPLOYEE}
          title={t('MENU.EMPLOYEE_INFO')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-diagram-2'
          to={EMPLOYEE_USER_MAPPING}
          title={t('MENU.EMP_USER_MAPPING')}
        />
        <SidebarMenuItem gated fontIcon='bi-clipboard-check' to={APPRAISAL} title='Appraisals' />
        <SidebarMenuItem
          gated
          fontIcon='bi-plus-slash-minus'
          to={INCREMENT}
          title={t('MENU.INCREMENT')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-envelope-plus'
          to={PROMOTION}
          title={t('MENU.PROMOTION')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-box-arrow-left'
          to={SEPARATION}
          title={t('MENU.SEPARATION')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-cash-coin'
          to={LOAN_ADVANCE}
          title={t('MENU.LOAN_ADVANCE')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-receipt-cutoff'
          to={ALL_PAYSLIPS}
          title='All Payslips'
        />
        <SidebarMenuItem gated fontIcon='bi-files' to={ALL_TAX_CERT} title='All Tax Certificate' />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to={LEAVE_ATTN}
        title={t('MENU.LEAVE_ATTN')}
        fontIcon='bi-calendar-check'
        anyOf={LEAVE_ATTN_ROUTES}
      >
        <SidebarMenuItem
          gated
          fontIcon='bi-box-arrow-right'
          to={LEAVE_TYPE}
          title={t('MENU.LEAVE_TYPE')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-calendar-x'
          to={LEAVE_FOR_EMPLOYEE}
          title={t('MENU.LEAVE_FOR_EMPLOYEE')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-fingerprint'
          to={ATTENDANCE_FOR_EMPLOYEE}
          title={t('MENU.ATTENDANCE_FOR_EMPLOYEE')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-calendar-plus'
          to={COMP_OFF_FOR_EMPLOYEE}
          title={t('MENU.COMP_OFF_FOR_EMPLOYEE')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-calendar2-week'
          to={EMPLOYEE_LEAVE}
          title={t('MENU.EMPLOYEE_LEAVE')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-list-stars'
          to={EMPLOYEE_ATTENDANCE}
          title={t('MENU.EMPLOYEE_ATTENDANCE')}
        />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to={APPROVALS}
        title={t('MENU.APPROVALS')}
        fontIcon='bi-check2-square'
        anyOf={APPROVAL_ROUTES}
      >
        <SidebarMenuItem gated fontIcon='bi-send' to={MY_REQUESTS} title={t('MENU.MY_REQUESTS')} />
        <SidebarMenuItem
          gated
          fontIcon='bi-inbox'
          to={PENDING_APPROVALS}
          title={t('MENU.PENDING_APPROVALS')}
        />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to={PAYROLL}
        title={t('MENU.PAYROLL')}
        fontIcon='bi-cash-stack'
        anyOf={PAYROLL_ROUTES}
      >
        <SidebarMenuItem
          gated
          fontIcon='bi-wallet2'
          to={PAYROLL_ELM}
          title={t('MENU.PAYROLL_ELM')}
        />
        <SidebarMenuItem gated fontIcon='bi-sliders' to={AMOUNT_ROUNDING} title='Amount Rounding' />
        <SidebarMenuItem
          gated
          fontIcon='bi-calendar-x'
          to={ATTENDANCE_PAY}
          title='Attendance Pay Policy'
        />
        <SidebarMenuItem gated fontIcon='bi-percent' to={TAX_CONFIG} title='Tax Configuration' />
        <SidebarMenuItem
          gated
          fontIcon='bi-piggy-bank'
          to={PROVIDENT_FUND}
          title='Provident Fund'
        />
        <SidebarMenuItem gated fontIcon='bi-gift' to={GRATUITY_FUND} title='Gratuity Fund' />
        <SidebarMenuItem
          gated
          fontIcon='bi-bank'
          to={PAYROLL_BANK_CONFIG}
          title='Bank Configuration'
        />
        <SidebarMenuItem gated fontIcon='bi-cash' to={EMPLOYEE_PAYROLL} title='Employee Payroll' />
        <SidebarMenuItem gated fontIcon='bi-calculator' to={PAYROLL_RUNS} title='Payroll Runs' />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to={REPORTS}
        title={t('MENU.REPORTS')}
        fontIcon='bi-bar-chart-line'
        anyOf={REPORTS_ROUTES}
      >
        <SidebarMenuItem gated fontIcon='bi-people' to={RPT_EMPLOYEE} title='Employee Report' />
        <SidebarMenuItem gated fontIcon='bi-star' to={RPT_APPRAISAL} title='Appraisal Report' />
        <SidebarMenuItem gated fontIcon='bi-cash-stack' to={RPT_PAYROLL} title='Payroll Summary' />
        <SidebarMenuItem
          gated
          fontIcon='bi-calendar-check'
          to={RPT_ATTN_SUMMARY}
          title='Attn & Leave Summary'
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-calendar3'
          to={RPT_MONTHLY_ATTENDANCE}
          title='Monthly Attendance'
        />
        <SidebarMenuItem gated fontIcon='bi-piggy-bank' to={RPT_PF} title='PF Statement' />
        <SidebarMenuItem gated fontIcon='bi-gift' to={RPT_GF} title='GF Statement' />
        <SidebarMenuItem
          gated
          fontIcon='bi-file-earmark-text'
          to={RPT_TAX_CERT}
          title='Tax Certificate'
        />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to={SETTINGS}
        title={t('MENU.SETTINGS')}
        fontIcon='bi-gear'
        anyOf={SETTINGS_ROUTES}
      >
        <SidebarMenuItem
          gated
          fontIcon='bi-geo-alt'
          to={OFFICE_LOCATION}
          title={t('MENU.OFFICE_LOCATION')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-diagram-3'
          to={DEPARTMENT}
          title={t('MENU.DEPARTMENT')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-person-badge'
          to={DESIGNATION}
          title={t('MENU.DESIGNATION')}
        />
        <SidebarMenuItem gated fontIcon='bi-bar-chart-steps' to={GRADES} title={t('MENU.GRADES')} />
        <SidebarMenuItem
          gated
          fontIcon='bi-person-lines-fill'
          to={EMP_TYPE}
          title={t('MENU.EMP_TYPE')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-toggles'
          to={EMPLOYMENT_STATUS}
          title={t('MENU.EMPLOYMENT_STATUS')}
        />
        <SidebarMenuItem gated fontIcon='bi-clock' to={SHIFTS} title={t('MENU.SHIFTS')} />
        <SidebarMenuItem gated fontIcon='bi-calendar-week' to={WEEKEND} title={t('MENU.WEEKEND')} />
        <SidebarMenuItem
          gated
          fontIcon='bi-calendar-event'
          to={HOLIDAY}
          title={t('MENU.HOLIDAY')}
        />
        <SidebarMenuItem gated fontIcon='bi-calendar3' to={CALENDAR} title={t('MENU.CALENDAR')} />
        <SidebarMenuItem
          gated
          fontIcon='bi-card-checklist'
          to={APPR_PARAM}
          title={t('MENU.APPR_PARAM')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-diagram-2'
          to={APPROVAL_WORKFLOW}
          title={t('MENU.APPROVAL_WORKFLOW')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-calendar-plus'
          to={COMP_OFF_CONFIG}
          title={t('MENU.COMP_OFF_CONFIG')}
        />
        <SidebarMenuItem
          gated
          fontIcon='bi-upc'
          to={EMP_CODE_CONFIG}
          title={t('MENU.EMP_CODE_CONFIG')}
        />
        <SidebarMenuItem gated fontIcon='bi-grid-3x3-gap' to={SECTION} title={t('MENU.SECTION')} />
        <SidebarMenuItem gated fontIcon='bi-building' to={UNIT} title={t('MENU.UNIT')} />
      </SidebarMenuItemWithSub>

      <SidebarMenuItem to={HELP} title='Help' fontIcon='bi-question-circle' />
    </>
  )
}
